// extracted by mini-css-extract-plugin
export var disabled = "_1j-5";
export var error = "_1j-1";
export var fitContent = "_1j-6";
export var hasSuffix = "_1j-4";
export var iconWrapper = "_1j-b";
export var infoIconWrapper = "_1j-d _1j-b";
export var input = "_1j-a";
export var inputWrapper = "_1j-0";
export var large = "_1j-8";
export var leadingIconWrapper = "_1j-c _1j-b";
export var measureBox = "_1j-e";
export var medium = "_1j-7";
export var readonly = "_1j-2";
export var small = "_1j-3";
export var suffix = "_1j-9";